@if(opened()) {
  <div class="patient-survey-dimension__questions">
    <app-ui-icon
      (click)="closeQuestionsPanel()"
      color="#8492A5"
      name="close"
      size="md"
    ></app-ui-icon>
    <h3>
      {{ dimension().name }}
    </h3>
    <p [innerHTML]="dimensionDescription()"></p>
    @for(question of dimension().questions; track question.text) {
      <div class="patient-survey-dimension__question">
        <p [innerHTML]="question.text"></p>
        <app-cpru-survey-score
          [score]="question.score"
        ></app-cpru-survey-score>
      </div>
    }
    <div class="patient-survey-dimension__link-btn2">
      <span (click)="closeQuestionsPanel()"> Stäng sektion </span>
    </div>
  </div>
}

